class EuroBookVisitMap extends HTMLElement {
  connectedCallback() {
    this.dataEl = this.querySelector('[data-book-visit-map-data]');
    this.card = this.querySelector('[data-book-visit-map-card]');
    this.pins = Array.from(this.querySelectorAll('[data-book-visit-map-pin]'));

    if (!this.dataEl || !this.card || !this.pins.length) return;

    let config;
    try {
      config = JSON.parse(this.dataEl.textContent);
    } catch {
      return;
    }

    this.locations = new Map(
      (config.locations || []).map((location) => [location.id, location])
    );
    this.defaultId = config.defaultId;

    this.cardTitle = this.card.querySelector('[data-book-visit-map-card-title]');
    this.cardMedia = this.card.querySelector('[data-book-visit-map-card-media]');
    this.cardImage = this.card.querySelector('[data-book-visit-map-card-image]');
    this.addressRow = this.card.querySelector('[data-book-visit-map-card-address]');
    this.addressText = this.card.querySelector('[data-book-visit-map-card-address-text]');
    this.hoursRow = this.card.querySelector('[data-book-visit-map-card-hours]');
    this.hoursText = this.card.querySelector('[data-book-visit-map-card-hours-text]');
    this.reviewText = this.card.querySelector('[data-book-visit-map-card-review]');

    this.onPinClick = (event) => {
      const pin = event.currentTarget;
      const locationId = pin.dataset.locationId;
      if (!locationId) return;
      this.selectLocation(locationId);
    };

    this.pins.forEach((pin) => {
      pin.addEventListener('click', this.onPinClick);
    });

    const initialId =
      this.defaultId && this.locations.has(this.defaultId)
        ? this.defaultId
        : this.pins[0]?.dataset.locationId;

    if (initialId) this.selectLocation(initialId);
  }

  disconnectedCallback() {
    this.pins?.forEach((pin) => {
      pin.removeEventListener('click', this.onPinClick);
    });
  }

  selectLocation(locationId) {
    const location = this.locations.get(locationId);
    if (!location) return;

    this.pins.forEach((pin) => {
      const isActive = pin.dataset.locationId === locationId;
      pin.classList.toggle('euro-book-visit-map__pin--active', isActive);
      pin.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (this.cardTitle) {
      this.cardTitle.textContent = location.name || '';
      this.cardTitle.hidden = !location.name;
    }

    if (this.addressRow && this.addressText) {
      this.addressText.textContent = location.address || '';
      this.addressRow.hidden = !location.address;
      // Keep the map href in sync with the active pin. The operator pastes a
      // full Maps URL into the theme editor; we never assemble one ourselves.
      if (location.maps_url) {
        this.addressText.setAttribute('href', location.maps_url);
        this.addressText.setAttribute('target', '_blank');
        this.addressText.setAttribute('rel', 'noopener noreferrer');
      } else {
        this.addressText.removeAttribute('href');
        this.addressText.removeAttribute('target');
        this.addressText.removeAttribute('rel');
      }
    }

    if (this.hoursRow && this.hoursText) {
      this.hoursText.textContent = location.hours || '';
      this.hoursRow.hidden = !location.hours;
    }

    if (this.reviewText) {
      this.reviewText.textContent = location.review_text || '';
      this.reviewText.hidden = !location.review_text;
    }

    if (this.cardMedia && this.cardImage) {
      if (location.image) {
        this.cardImage.src = location.image;
        this.cardImage.alt = location.name || '';
        this.cardImage.hidden = false;
        this.cardMedia.classList.remove('euro-book-visit-map__card-media--placeholder');
      } else {
        this.cardImage.removeAttribute('src');
        this.cardImage.alt = '';
        this.cardImage.hidden = true;
        this.cardMedia.classList.add('euro-book-visit-map__card-media--placeholder');
      }
    }
  }
}

if (!customElements.get('euro-book-visit-map')) {
  customElements.define('euro-book-visit-map', EuroBookVisitMap);
}
